import { IApplicationState } from '../../types/redux';
import { ISeoLinksTab } from '../../types/seoTabsLinks';

export function selectSeoTabsLinks(state: IApplicationState): ISeoLinksTab[] {
  return state.seoTabsLinks || [];
}
